import { canonicalPublicArtworkUrl } from "./trackArtwork";

export const MEDIA_SEEK_SECONDS = 10;

export function publicMediaArtwork(track, origin = "") {
  const fallback = `${String(origin || "").replace(/\/$/, "")}/og-cover.png`;
  const candidate = canonicalPublicArtworkUrl(
    track?.artworkVariants?.webp640?.url || track?.imageThumbnail640 || track?.imageURL || ""
  );
  if (!candidate) return fallback;
  try {
    const url = new URL(candidate, origin || undefined);
    if (url.protocol !== "https:" || /\/(?:aid|admin)\//i.test(url.pathname)) return fallback;
    if (/^(?:firebasestorage\.googleapis\.com|storage\.googleapis\.com)$/i.test(url.hostname) &&
      !/\/o\/images%2F/i.test(url.pathname)) return fallback;
    return url.href;
  } catch {
    return fallback;
  }
}

export function buildMediaMetadata(track, origin = "") {
  const artworkUrl = publicMediaArtwork(track, origin);
  const type = /\.webp(?:$|\?)/i.test(artworkUrl) ? "image/webp" :
    /\.jpe?g(?:$|\?)/i.test(artworkUrl) ? "image/jpeg" : "image/png";
  return {
    title: track?.title || "VonTheKeyz",
    artist: track?.artist || track?.artistName || "VonTheKeyz",
    album: track?.album || "VonTheKeyz",
    artwork: [{
      src: artworkUrl,
      sizes: "512x512",
      type,
    }],
  };
}

export function validPositionState(audio) {
  const duration = Number(audio?.duration);
  const playbackRate = Number(audio?.playbackRate) || 1;
  const rawPosition = Number(audio?.currentTime);
  if (!Number.isFinite(duration) || duration <= 0 || !Number.isFinite(rawPosition)) return null;
  return {
    duration,
    playbackRate: playbackRate > 0 ? playbackRate : 1,
    position: Math.min(duration, Math.max(0, rawPosition)),
  };
}

export function seekAudio(audio, seconds) {
  if (!audio || !Number.isFinite(Number(seconds))) return false;
  const duration = Number(audio.duration);
  const next = Number.isFinite(duration) && duration > 0
    ? Math.min(duration, Math.max(0, Number(seconds)))
    : Math.max(0, Number(seconds));
  try {
    audio.currentTime = next;
    return true;
  } catch {
    return false;
  }
}
